import { render, staticRenderFns } from "./contextmenu.vue?vue&type=template&id=5657c736&scoped=true"
import script from "./contextmenu.vue?vue&type=script&lang=js"
export * from "./contextmenu.vue?vue&type=script&lang=js"
import style0 from "./contextmenu.vue?vue&type=style&index=0&id=5657c736&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657c736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5657c736')) {
      api.createRecord('5657c736', component.options)
    } else {
      api.reload('5657c736', component.options)
    }
    module.hot.accept("./contextmenu.vue?vue&type=template&id=5657c736&scoped=true", function () {
      api.rerender('5657c736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BjGraph/contextmenu.vue"
export default component.exports